import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Input from 'components/atoms/Input'
import Switch from 'components/atoms/Switch'
import apiPost from 'lib/network/apiPost'
import apiPut from 'lib/network/apiPut'
import apiGet from 'lib/network/apiGet'
import notify from 'components/atoms/Notify'
import { trim } from 'lodash'

const AddMakeModal = ({ onSuccess, close, id = null, close: customClose }) => {
  const { t } = useTranslation()
  console.log('id', id)
  const [formData, setFormData] = useState({
    make: '',
    makeAr: '',
    active: true,
  })

  useEffect(() => {
    if (id) {
      fetchMakeData()
    }
  }, [id])

  const fetchMakeData = async () => {
    try {
      const response = await apiGet(`make/${id}`)
      if (response.success) {
        const data = response.data
        setFormData({
          make: data.make || '',
          makeAr: data.makeAr || '',
          active: data.active !== undefined ? data.active : true,
        })
      } else {
        notify.error(t('addMakeModal.messages.failedToFetchMakeData'))
      }
    } catch (error) {
      console.error('Error fetching make data:', error)
      notify.error(t('addMakeModal.messages.failedToFetchMakeData'))
    }
  }

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSwitchChange = checked => {
    setFormData(prevData => ({
      ...prevData,
      active: checked,
    }))
  }

  const handleSubmit = async () => {
    if (!trim(formData.make)) {
      notify.error(t('addMakeModal.messages.makeNameRequired'))
      return
    }
    if (!trim(formData.makeAr)) {
      notify.error(t('addMakeModal.messages.makeArabicNameRequired'))
      return
    }

    try {
      let response
      if (id) {
        response = await apiPut(`make/${id}`, formData)
        if (response.success) {
          notify.success(t('addMakeModal.messages.makeUpdatedSuccessfully'))
        }
      } else {
        response = await apiPost('make', formData)
        if (response.success) {
          notify.success(t('addMakeModal.messages.makeAddedSuccessfully'))
        }
      }

      if (response.success) {
        onSuccess()
        if (customClose) {
          customClose()
        }
        close()
      } else {
        notify.error(response.message || t('addMakeModal.messages.operationFailed'))
      }
    } catch (error) {
      console.error('Error saving make:', error)
      notify.error(t('addMakeModal.messages.failedToSaveMake'))
    }
  }

  const handleCancel = () => {
    if (customClose) {
      customClose()
    }
    close()
  }

  return (
    <div className="space-y-6">
      <div>
        <label htmlFor="make" className="block text-sm font-medium text-gray-700 mb-2">
          {t('addMakeModal.labels.vehicleMake')}
        </label>
        <input
          type="text"
          name="make"
          value={formData.make}
          onChange={handleChange}
          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          placeholder={t('addMakeModal.placeholders.enterVehicleMake')}
        />
      </div>
      <div>
        <label htmlFor="makeAr" className="block text-sm font-medium text-gray-700 mb-2">
          {t('addMakeModal.labels.vehicleArabicMake')}
        </label>
        <input
          type="text"
          name="makeAr"
          value={formData.makeAr}
          onChange={handleChange}
          dir="rtl"
          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          placeholder={t('addMakeModal.placeholders.enterVehicleMakeArabic')}
        />
      </div>

      <div className="flex items-center justify-between">
        <label htmlFor="active" className="block text-sm font-medium text-gray-700">
          {t('addMakeModal.labels.active')}
        </label>
        <Switch value={formData.active} onChange={handleSwitchChange} />
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          onClick={handleCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {t('addMakeModal.buttons.cancel')}
        </button>
        <button
          onClick={handleSubmit}
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-dark-600 hover:bg-dark-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dark-500"
        >
          {id ? t('addMakeModal.buttons.updateMake') : t('addMakeModal.buttons.addMake')}
        </button>
      </div>
    </div>
  )
}

export default AddMakeModal
